import React from "react";

function Loader() {
  return (
    <div className="wrapper">
      <span className="circle circle-1"></span>
      <span className="circle circle-2"></span>
      <span className="circle circle-3"></span>
      <span className="circle circle-4"></span>
      <span className="circle circle-5"></span>
    </div>
  );
}

export default Loader;
